<script lang="ts" setup>
  defineEmits<{
    (event: 'success'): void;
  }>();

  const projectConfig = useProjectConfig();
</script>

<template>
  <div class="mp-social-login">
    <AuthPartsSigninButtonGoogle
      v-if="projectConfig.features.socialLogin.google"
      size="lg"
      class="mp-social-login__button"
      @success="$emit('success')"
    />
    <AuthPartsSigninButtonFacebook
      v-if="projectConfig.features.socialLogin.facebook"
      size="lg"
      class="mp-social-login__button"
      @success="$emit('success')"
    />
    <AuthPartsSigninButtonApple
      v-if="projectConfig.features.socialLogin.apple"
      size="lg"
      class="mp-social-login__button"
      @success="$emit('success')"
    />
  </div>
</template>

<style scoped lang="scss">
  .mp-social-login {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-40);
    justify-content: center;
    flex-wrap: wrap;

    @include screen-md {
      flex-direction: row;
    }

    &__button {
      @include screen-md {
        flex: 1;
        $width: 152px;
        min-width: $width;
        max-width: $width;
      }
    }
  }
</style>
